import {ajaxUserMainFilter} from "../../resources/js/modules/ajaxUsersFilter";

window.addEventListener('load', () => {
    const filters = document.querySelectorAll('.sk-acc-filter.members-filter');
    filters.length > 0 && ajaxUserMainFilter(filters, 'user');

    filters.length > 0 && filters.forEach(member => {
        const nav = member.querySelector('.members-filter__nav');
        const magicLine = nav?.querySelector('.magic-line');
        let activeNav = nav?.querySelector('.members-filter__nav-btn.active');

        if (!magicLine || !activeNav) return;

        function moveMagicLine(target) {
            const btnRect = target.getBoundingClientRect();
            const navRect = nav.getBoundingClientRect();

            magicLine.style.width = `${btnRect.width - 10}px`;
            magicLine.style.transform = `translateX(${(btnRect.left + 5) - navRect.left}px)`;
        }

        member.addEventListener('click', (e) => {
            const btn = e.target.closest('.members-filter__nav-btn');
            if (!btn) return;

            if (activeNav !== btn) {
                activeNav.classList.remove('active');
                btn.classList.add('active');
                member.querySelector('.members-filter__tab.active')?.classList.remove('active');
                member.querySelector(`#${btn.dataset.tab}`)?.classList.add('active');
                moveMagicLine(btn);

                activeNav = btn;
            }
        });

        if (activeNav) moveMagicLine(activeNav);

        window.addEventListener('resize', () => (activeNav) && moveMagicLine(activeNav));
    });
});
